import { OrganizationRiskAnalysesStats, OrganizationRiskAnalysesStatsDTO } from './organizationRiskAnalysesStats.types';

// eslint-disable-next-line import/prefer-default-export
export const parseOrganizationRiskAnalysesStatsForFE = (dto: OrganizationRiskAnalysesStatsDTO): OrganizationRiskAnalysesStats => ({
  riskQuadrant1: dto.risk_quadrant_1,
  riskQuadrant2: dto.risk_quadrant_2,
  riskQuadrant3: dto.risk_quadrant_3,
  riskQuadrant4: dto.risk_quadrant_4,
});
